module.exports = __webpack_public_path__ + "static/img/155.3f03f24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/155.png
// module id = QQ9Y
// module chunks = 0